<template>
    <div>
        <div class="row" v-if="showCompanyData">
            <div class="form-group col-lg-4">
                <label class="font-weight-bold" :for="'name' + _uid">{{ $t('company.name') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="company.name"
                       :name="'name' + _uid"
                       :id="'name' + _uid">
            </div>
            <div class="form-group col-lg-4">
                <label class="font-weight-bold" :for="'vatNumber' + _uid">{{ $t('company.vatNumber') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="company.vatNumber"
                       :name="'vatNumber' + _uid"
                       :id="'vatNumber' + _uid">
            </div>
            <div class="form-group col-lg-4">
                <label class="font-weight-bold" :for="'bulstatUic' + _uid">{{ $t('company.bulstatUic') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="company.bulstatUic"
                       :id="'bulstatUic' + _uid">
            </div>
            <div class="form-group col-lg-4">
                <label class="font-weight-bold" :for="'email' + _uid">{{ $t('email') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="company.email"
                       :name="'email' + _uid"
                       :id="'email' + _uid">
            </div>
            <div class="form-group col-lg-4">
                <label class="font-weight-bold" :for="'fax' + _uid">{{ $t('company.fax') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="company.fax"
                       :id="'fax' + _uid">
            </div>
            <div class="form-group col-lg-4">
                <label class="font-weight-bold" :for="'phone' + _uid">{{ $t('company.phone') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="company.phone"
                       :name="'phone' + _uid"
                       :id="'phone' + _uid">
            </div>
            <div class="form-group col-lg-4">
                <label class="font-weight-bold" :for="'url' + _uid">{{ $t('company.url') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="company.url"
                       :id="'url' + _uid">
            </div>
            <div class="form-group col-lg-12">
                <label class="font-weight-bold" :for="'description' + _uid">{{ $t('company.description') }}</label>
                <textarea rows="3" class="form-control" readonly
                          v-model="company.description"
                          :id="'description' + _uid">
                </textarea>
            </div>
        </div>

        <br>

        <contact-person-details :person="company.manager" :title="$t('company.manager')" v-if="showCompanyManager"></contact-person-details>

        <br>

        <contact-person-details :person="company.contact" :title="$t('company.contact')" v-if="showCompanyContact"></contact-person-details>

        <br>

        <address-details :address="company.registeredAddress" :title="$t('company.registeredAddress')" v-if="showRegisteredAddress"></address-details>

        <br>

        <address-details :address="company.contactAddress" :title="$t('company.contactAddress')" v-if="showContactAddress"></address-details>

        <br>

        <bank-account-details :bankAccount="company.bankAccount" :title="$t('company.bankAccount')" v-if="showBankAccount"></bank-account-details>
    </div>
</template>

<script>
    import AddressDetails from '@/components/address/AddressDetails';
    import BankAccountdDetails from '@/components/bankAccount/BankAccountDetails';
    import { CompanyDetails } from '@/models/models';
    import ContactPersonDetails from "@/components/person/ContactPersonDetails";

    export default {
       props: {
            showContactAddress: {
                Boolean,
                default: true
            },
            showBankAccount: {
                Boolean,
                default: true
            },
            showRegisteredAddress: {
                Boolean,
                default: true
            },
            showCompanyContact: {
                Boolean,
                default: true
            },
            showCompanyManager: {
                Boolean,
                default: true
            },
            showCompanyData: {
                Boolean,
                default: true
            },
            company: CompanyDetails
        },
        components: {
            'address-details': AddressDetails,
            'bank-account-details': BankAccountdDetails,
            ContactPersonDetails
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
